export const DsAppBarDefaultProps = {
    color: 'default',
    enableColorOnDark: true,
    elevation: 0
};
